<template>
  <div
    :class="minimize ? 'col-xl-4' : 'col-xl-12'"
    style="transition: all 0.5s ease"
    :id="`stashinfo-${stashAccount.id}`"
  >
    <!--begin::Mixed Widget 7-->
    <div class="card card-custom gutter-b">
      <div class="card-header border-bottom-0 ribbon ribbon-clip ribbon-right">
        <div class="ribbon-target" style="top: 15px; height: 45px">
          <span class="ribbon-inner bg-primary"></span
          ><i
            class="fa text-white cursor-pointer"
            :class="minimize ? 'fa-cog' : 'fa-times-circle'"
            @click="changeSize"
          ></i>
        </div>
        <div class="card-title">
          <div class="d-flex flex-wrap align-items-center pt-3">
            <!--begin:Pic-->
            <div class="symbol symbol-80 mr-5">
              <span class="symbol-label">
                <img
                  src="/media/stash/stash_icon.png"
                  class="h-100 align-self-center rounded-sm"
                  :alt="stashAccount.name"
                />
              </span>
            </div>
            <!--end:Pic-->

            <!--begin:Title-->
            <div class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3">
              <div
                class="text-dark font-weight-bolder text-hover-primary font-size-h5"
                v-html="stashAccount.name"
              ></div>
              <div
                class="text-muted font-weight-bold font-size-lg"
                v-html="stashAccount.description"
              ></div>
            </div>
            <!--end:Title-->
          </div>
        </div>
      </div>
      <!--begin::Body-->
      <div class="card-body">
        <!--begin:Stats-->
        <div class="d-flex flex-column w-100">
          <span class="text-dark mr-2 font-size-lg font-weight-bolder pb-3">
            {{ $t('detail.stash.storageUsage') }}
            <small
              >( {{ $customFunctions.convertMBtoGB(stashAccount.used_mb) }} GB
              <span>of {{ stashAccount.quota }}</span
              >)</small
            >
          </span>

          <div class="progress progress-xs w-100">
            <div
              class="progress-bar bg-danger"
              role="progressbar"
              :style="`width: ${calcValue}%`"
              aria-valuenow="50"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>
        <!--end:Stats-->

        <AccountUsersMin v-if="minimize" :accountUsers="accountUsers" />
        <AccountUsersMax
          v-else
          :accountUsers="accountUsers"
          :stashServiceDetail="stashServiceDetail"
          :stashAccount="stashAccount"
          @updateUsers="getAccountUsers"
        />
        <DeleteAccount v-if="!minimize" :stashAccount="stashAccount" />
      </div>
      <!--end::Body-->
    </div>
    <!--end::Mixed Widget 7-->
  </div>
</template>

<script>
// Services
import ApiService from '@/core/services/api.service'

export default {
  name: 'StashInfo',
  props: {
    stashAccount: Array | String,
    stashServiceDetail: Array | String,
    closeStashInfo: String,
  },
  data() {
    return {
      minimize: true,
      accountUsers: [],
    }
  },
  computed: {
    calcValue() {
      if (this.stashAccount != '' && this.stashAccount.used_mb > 0) {
        return (
          (this.$customFunctions.convertMBtoGB(this.stashAccount.used_mb) /
            this.stashAccount.quota) *
          100
        ).toFixed(0)
      }
      return 0
    },
  },
  created() {
    this.getAccountUsers()
  },
  methods: {
    changeSize() {
      this.minimize = !this.minimize
      setTimeout(() => {
        var cardElement = document.getElementById(
          `stashinfo-${this.stashAccount.id}`
        )
        var rect = cardElement.getBoundingClientRect()
        if (rect) {
          window.scrollTo({ top: rect.top - 75, behavior: 'smooth' })
        }
      }, 200)

      if (!this.minimize) {
        this.$emit('closeAllStashInfo', this.stashAccount.id)
      }
    },
    getAccountUsers() {
      ApiService.get(`stash/accounts/${this.stashAccount.id}/users`)
        .then(({ data }) => {
          this.accountUsers = data.data
        })
        .catch((err) => {
          this.accountUsers = []
        })
    },
  },
  watch: {
    closeStashInfo(newVal) {
      if (newVal != '' && newVal != this.stashAccount.id) this.minimize = true
    },
  },
  components: {
    AccountUsersMin: () => import('@/components/stash/v2/AccountUsersMin'),
    AccountUsersMax: () => import('@/components/stash/v2/AccountUsersMax'),
    DeleteAccount: () => import('@/components/stash/v2/DeleteAccount'),
  },
}
</script>
